export const useInputImageRenderer2 = (inputEl, callback) => {
  const inputImageRenderer2 = () => {
    const file = inputEl.value.files[0];
    const reader = new FileReader();

    reader.addEventListener(
      "load",
      () => {
        callback(reader.result);
      },
      false
    );

    if (file) {
      reader.readAsDataURL(file);
    }
  };
  return {
    inputImageRenderer2,
  };
};

export const _ = null;
